<template>
  <div @click="menu = true">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="computedDateFormatted"
          :label="label"
          append-icon='event'
          readonly
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
          :clearable="clearable"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        @input="menu = false"
        :disabled="disabled"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    label: String,
    initialDate: String,
    disabled: Boolean,
    clearable: Boolean
  },
  data () {
    return {
      currentDate: moment().format('YYYY-MM-DD'),
      date: null,
      dateFormatted: null,
      menu: false
    }
  },
  computed: {
    computedDateFormatted: {
      get () {
        return this.formatDate(this.date)
      },
      set (value) {
        this.date = value
      }
    }
  },
  created () {
    this.date = this.initialDate || null
    this.dateFormatted = this.formatDate(this.date)
  },
  watch: {
    date (value) {
      this.dateFormatted = this.formatDate(value)
    },
    dateFormatted (value) {
      this.$emit('change', this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${ day }/${ month }/${ year }`
    }
  }
}
</script>
